import { useLocation } from "react-router-dom";

import { Heading, Link, Stack } from "@seneca/senekit";

import { linkToAnonymousCourseDiscoveryWithDefaultFilters } from "features/anonymous-pages/course-discovery/links";
import { isInClassroom } from "features/classroom/routes/links";

type Props = {
  headerMessage?: string;
  showTryWithoutSigningUp?: boolean;
};

export function SignUpOptionsCardHeader({ headerMessage }: Props) {
  const location = useLocation();
  const inClassroom = !!isInClassroom(location.pathname);

  return (
    <Stack space="medium" align="center">
      <Heading level="3" align="center">
        {headerMessage ?? "Sign up"}
      </Heading>
      {!inClassroom && (
        <Link
          size="small"
          to={linkToAnonymousCourseDiscoveryWithDefaultFilters()}
        >
          Try without signing up?
        </Link>
      )}
    </Stack>
  );
}

export function SignUpFormHeader({ headerMessage }: Props) {
  return (
    <Heading level="4" align={["left", "center"]}>
      {headerMessage ?? "Sign up"}
    </Heading>
  );
}
